// extracted by mini-css-extract-plugin
module.exports = {"root":"_a1503e"};